/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

import {
  Spinner,
  Heading,
  SpanWithData,
  SvgIcon,
  NavLink
} from '../'

import {
  readablePhoneNumber
} from '../../utils'

class IdentitySummary extends React.Component {
  static propTypes = {
    identity: PropTypes.string.isRequired,
    className: PropTypes.string
  }

  render() {
    if (this.props.data.loading) {
      return <Spinner type="brand" />
    }

    if (this.props.data.error) {
      return <div>Failed to load client information</div>
    }

    let identity = this.props.data.identity

    return (
      <div className={`slds-grid slds-wrap ${this.props.className ? this.props.className : ''}`}>
        <div className="slds-col slds-grid slds-size_1-of-1">
          <SvgIcon
            variant='utility'
            symbol={identity.isEmployer ? 'company' : 'user'}
            size='small'
            colour='light'
            className='slds-m-right_small'
          />
          <Heading
            size="medium"
            className="slds-m-bottom_large">
            <NavLink to={`/os/identity/${identity.id}`}>
              <strong>{`${identity.firstName} ${identity.lastName}`}</strong>
            </NavLink>
          </Heading>
        </div>
        {identity.contacts.edges.length > 0
          ? <EmployerContactInfo contact={identity.contacts.edges[0].node} />
          : null
        }
        <div className="slds-col slds-size_3-of-3 slds-medium-size_3-of-3 slds-large-size_1-of-3">
          <strong>ID number:</strong>
        </div>
        <div className="slds-col slds-size_3-of-3 slds-medium-size_3-of-3 slds-large-size_2-of-3">
          {identity.identityValue}
        </div>
        <div className="slds-col slds-size_3-of-3 slds-medium-size_3-of-3 slds-large-size_1-of-3">
          <strong>Language:</strong>
        </div>
        <div className="slds-col slds-size_3-of-3 slds-medium-size_3-of-3 slds-large-size_2-of-3">
          {identity.language
            ? <SpanWithData forField="IdentityLanguage" searchKey={identity.language} />
            : 'Unknown'
          }
        </div>
        <div className="slds-col slds-size_3-of-3 slds-medium-size_3-of-3 slds-large-size_1-of-3">
          <strong>Contact no.:</strong>
        </div>
        <div className="slds-col slds-size_3-of-3 slds-medium-size_3-of-3 slds-large-size_2-of-3">
          {identity.contactNumber.edges.length > 0
            ? readablePhoneNumber(identity.contactNumber.edges[0].node.addressValue)
            : "Unknown"
          }
        </div>
      </div>
    )
  }
}

const EmployerContactInfo = (props) => (
  <React.Fragment>
    <div className="slds-col slds-size_3-of-3 slds-medium-size_3-of-3 slds-large-size_1-of-3">
      <strong>Employer:</strong>
    </div>
    <div className="slds-col slds-size_3-of-3 slds-medium-size_3-of-3 slds-large-size_2-of-3">
      {props.contact.employer.friendlyName}
    </div>
    <div className="slds-col slds-size_3-of-3 slds-medium-size_3-of-3 slds-large-size_1-of-3">
      <strong>Position:</strong>
    </div>
    <div className="slds-col slds-size_3-of-3 slds-medium-size_3-of-3 slds-large-size_2-of-3">
      {props.contact.position}
    </div>
    <div className="slds-col slds-size_3-of-3 slds-medium-size_3-of-3 slds-large-size_1-of-3">
      <strong>Role:</strong>
    </div>
    <div className="slds-col slds-size_3-of-3 slds-medium-size_3-of-3 slds-large-size_2-of-3">
      {props.contact.role}
    </div>
  </React.Fragment>
)

export const getIdentityDetails = gql`
  query($id: ID!) {
    identity(id: $id) {
      id
      firstName
      lastName
      identityValue
      language
      isEmployer
      contactNumber: addresses(addressType: "msisdn", default: true) {
        edges {
          node {
            id
            addressValue
          }
        }
      }
      contacts {
        edges {
          node {
            id
            role
            position
            employer {
              id
              friendlyName
            }
          }
        }
      }
    }
  }
`

export const withData =
  graphql(getIdentityDetails, {
    options: (ownProps) => ({
      variables: {
        id: ownProps.identity
      }
    })
  })

export default withData(IdentitySummary)



// WEBPACK FOOTER //
// ./src/components/identity-summary/index.js